import pxToRem from "assets/theme/functions/pxToRem";

const tableCell = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(13)} ${pxToRem(16)}`,
      borderBottom: "1px solid #EEF2F7",
      color: "#334155",
      fontSize: pxToRem(13),
      verticalAlign: "middle",
    },
    head: {
      backgroundColor: "#F8FAFC",
      color: "#475569",
      fontWeight: 800,
      fontSize: pxToRem(12),
      whiteSpace: "nowrap",
    },
  },
};

export default tableCell;
